import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export default function PendingList({ title, items = [], columns = [] }) {
    return (
        <div className="mt-4">
            <h3 className="mb-2">{title}</h3>
            {items.length === 0 ? (
                <p style={{ color: '#6b7280' }}>Nenhum pendente 🎉</p>
            ) : (
                <DataTable value={items} responsiveLayout="scroll">
                    {columns.map(col => (
                        <Column
                            key={col.field}
                            field={col.field}
                            header={col.header}
                            body={col.body}
                        />
                    ))}
                </DataTable>
            )}
        </div>
    );
}
